<!-- ADD-MODAL-STRUCTURE -->
<div class="master-modal coupon_modal" role="dialog">
  <div class="modal-dialog">
    <!-- Modal content-->
    <div class="modal-content">
      <!-- Modal-Header -->
      <div class="modal-header">
        <h4 class="modal-title">Delete {{ name }} ? </h4>
        <div class="modal_close_btn">
          <span (click)="dialogClose('no')" class="modal-close"><i class="material-icons">close</i></span>
        </div>
      </div>
      <!-- Modal content-->
        <div mat-dialog-content>
          <!-- Modal-Body -->
          <div class="modal-body">
            <p>Do you really want to delete this {{ name }} ?</p>
          </div>
        </div>
      <!-- Modal-Footer -->
      <div class="modal-footer">
        <div mat-dialog-actions class="modal_footer">
          <button type="button" mat-button (click)="dialogClose('no')" class="modal-cancel-btn modal-footer-btn">
            <span>No</span>
          </button>
          <button type="button" mat-button class="modal-save-btn global-btn modal-footer-btn"
          (click)="deleteItem()">
            <span>Yes</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
